function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/ React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
}, /*#__PURE__*/ React.createElement("path", {
    fill: "#409EFF",
    d: "M14.336 4.5l9.856 19.148h-3.815L12.828 8.98 5.28 23.648H1.465L11.321 4.5z"
}), /*#__PURE__*/ React.createElement("path", {
    fill: "#409EFF",
    d: "M21.224 4.5h3.016l9.844 19.148h-3.813L22.73 8.985l-3.041 5.917-1.908-3.707z"
}), /*#__PURE__*/ React.createElement("path", {
    d: "M14.372 24.496c3.32 0 5.41 1.55 5.457 4.436v.098c0 .849.38 1.143 1.962 1.143 2.145 0 5.555-.874 10.143-2.64l1.796-.697 1.228 3.162-1.581.613c-5.057 1.963-8.888 2.954-11.586 2.954-3.257 0-5.306-1.562-5.352-4.435v-.1c0-.835-.408-1.142-2.067-1.142-2.221 0-5.738.876-10.466 2.646l-1.809.682L.9 28.042l1.587-.598c5.192-1.96 9.124-2.948 11.885-2.948z",
    fill: "#38BEDE"
}));
function SvgLogo(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        viewBox: "0 0 36 36"
    }, props), _ref);
}
export default SvgLogo;
